export { default } from "../client/script";
export * from "../client/script";

//# sourceMappingURL=script.js.map